"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var phocus_1 = require("phocus");
var KeyCommand = /** @class */ (function (_super) {
    __extends(KeyCommand, _super);
    function KeyCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KeyCommand.prototype.keys = function () {
        return this.props.action.keys
            .filter(function (k) { return k !== "None"; })
            .map(function (k) { return phocus_1.Hotkey.displayKey(k); });
    };
    KeyCommand.prototype.render = function () {
        return (React.createElement("span", { className: "phocus-key-command" },
            this.keys().length === 0 && "unbound",
            this.keys().map(function (key, i) {
                return (React.createElement("span", { key: i },
                    !!i && " or ",
                    React.createElement("span", { className: "phocus-key-command--key" }, key)));
            })));
    };
    return KeyCommand;
}(React.Component));
exports.KeyCommand = KeyCommand;
//# sourceMappingURL=key-command.js.map